import styled from "styled-components";
import { createShouldForwardPropBlockList, deepMerge } from "../utils/helper";
import { type ToastProps } from "./toast";
import { getAnimation, getBorderRadius } from "./toast.styles.utils";

type WrapperProps = Pick<ToastProps, "position" | "visible" | "rounded">;

export const Wrapper = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["position", "visible", "rounded"]),
})<WrapperProps>(({ position, visible, rounded, theme }) => ({
    ...deepMerge(getAnimation(visible, position, theme), getBorderRadius(rounded, theme)),
    boxShadow: theme.boxShadow.DEFAULT,
    maxWidth: "300px",
    [`@media (min-width: ${theme.screens.sm})`]: {
        maxWidth: "400px",
    },
    [`@media (min-width: ${theme.screens.md})`]: {
        maxWidth: "500px",
    },
}));
